import { render, staticRenderFns } from "./CreateDriver.vue?vue&type=template&id=3b8fe514&scoped=true&"
import script from "./CreateDriver.vue?vue&type=script&lang=js&"
export * from "./CreateDriver.vue?vue&type=script&lang=js&"
import style0 from "./CreateDriver.vue?vue&type=style&index=0&id=3b8fe514&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../shared/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8fe514",
  null
  
)

export default component.exports